export function onlyNumbers(string: string): string {
    if (!string) return string;

    return string.replace(/\D/g, '');
}
